module.exports = __webpack_public_path__ + "img/browser-smart-construction-button.4afcc62d.png";